// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { Question } from "../QuestionnaireTypes";
import { fbt } from "fbt";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { postcodeValidator } from "postcode-validator";

// Runs on the original password field.
export const getCopyCatMatchValidator = (copycatfield: string) => {
  return (
    text: string | null,
    questions: { [key: string]: Question }
  ): string | undefined => {
    const copyCatInput = { ...questions[copycatfield] };
    if (text !== copyCatInput.value) {
      copyCatInput.error = "Passwords must match";
    } else {
      copyCatInput.error = undefined;
    }
    questions[copycatfield] = copyCatInput;
    return;
  };
};

// Runs on the duplicate password field.
export const getMasterMatchValidator = (masterfield: string) => {
  return (text: string | null, questions: { [key: string]: Question }) => {
    const masterInput = { ...questions[masterfield] };
    if (text !== masterInput.value) {
      return "Passwords must match";
    }
    questions[masterfield] = masterInput;
    return;
  };
};

export const validateBoxChecked = (checked: string | null) => {
  if (checked === null) {
    return;
  }
  if (checked === "false") {
    return "You must check this box to proceed.";
  }
  return;
};

export const validateEmail = (text: string | null) => {
  if (!text) {
    return;
  }
  const validationPattern = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  const isValid = validationPattern.test(text);
  if (!isValid) {
    return "Invalid Email";
  }
  return;
};

export const validateName = (text: string | null) => {
  if (!text) {
    return;
  }
  if (text.length < 2) {
    return "Must be at least 2 characters.";
  }
  return;
};

export const validatePasswordLength = (text: string | null) => {
  if (!text || text.length < 8) {
    return "At least 8 characters long";
  }
  // TODO: add other checks for password complexity.
  return;
};

export const validateZipCode = (text: string | null) => {
  if (!text) {
    return;
  }
  if (!postcodeValidator(text, "US")) {
    return "Enter a valid Zip Code";
  }
  return;
};

export const validatePhoneNumber = (text: string | null) => {
  if (!text) {
    return;
  }
  const phoneNumber = parsePhoneNumberFromString(text, "US");

  if (!phoneNumber || !phoneNumber?.isValid() || phoneNumber.country !== "US") {
    return fbt(
      "Enter a valid US phone number",
      "Invalid phone number message",
      { project: "audere" }
    );
  }
  return;
};
